import styled from 'styled-components';

/** Título do portal no banner — não é h1 (h1 fica no PageTitle da página). */
export const Title = styled.span`
  && {
    display: inline-block;
    font-size: ${({ theme }) => `${22 + 2 * theme.zoomFonte}px`};
    color: ${({ color }) => color};
    font-weight: 600;
    line-height: 1.35;
    max-width: min(70vw, 640px);
    padding: 6px 12px;
    border-radius: 4px;
    background: ${({ background }) => background};
    text-shadow: none;
  }
`;
